import { SecondarySideMenuI } from '../../../../../shared/interfaces/secondary-side-menu.interface';

export const COURSE_SECTION_SIDE_MENU_ITEMS: SecondarySideMenuI[] = [
  {
    translationPath: 'aolReport.title',
    activeIcon: 'svgs/side-menu/active-evaluation-criterion.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-evaluation-criterion.svg',
    route: () => 'aol-report',
    alt: 'Aol Report',
  },
  {
    translationPath: 'coursesCompletions.title',
    activeIcon: 'svgs/side-menu/active-institutional-goals.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-institutional-goals.svg',
    route: () => 'courses-completions',
    alt: 'Courses Completions',
  },
  {
    translationPath: 'coursesOutlier.details.title',
    activeIcon: 'svgs/side-menu/active-institutional-goals.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-institutional-goals.svg',
    route: () => 'course-outlier',
    alt: 'Upper and Lower',
  },
  {
    translationPath: 'Courses CLOs',
    activeIcon: 'svgs/side-menu/active-institutional-goals.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-institutional-goals.svg',
    route: () => 'courses-clos',
    alt: 'Courses CLOs',
  },
];
